import { render } from "./UsernameInput.vue?vue&type=template&id=44831748&scoped=true"
import script from "./UsernameInput.vue?vue&type=script&lang=js"
export * from "./UsernameInput.vue?vue&type=script&lang=js"

import "./UsernameInput.vue?vue&type=style&index=0&id=44831748&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-44831748"

export default script